import CatalogHorizontalTile from './CatalogHorizontalTile.vue';

export { CatalogHorizontalTile };
export default CatalogHorizontalTile;
